import { api } from "@/lib/api";
import { toast } from "sonner";

export const DOC_CATS = [
  ["all", "Toate"], ["contract", "Contracte"], ["addendum", "Acte adiționale"], ["report", "Rapoarte lunare"],
  ["permit", "Avize & Autorizații"], ["drawing", "Planuri"], ["other", "Altele"],
];
export const docCategoryLabel = (k) => (DOC_CATS.find(([c]) => c === k) || [])[1] || "Altele";
export const isDocLink = (d) => d.kind === "link" || !!d.url;

export async function openDocument(doc, setBusy) {
  if (isDocLink(doc)) { window.open(doc.url, "_blank", "noopener"); return; }
  setBusy?.(doc.id);
  try {
    const resp = await api.get(`/documents/${doc.id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(resp.data); const a = document.createElement("a");
    a.href = url; a.download = doc.filename || doc.name; document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
  } catch { toast.error("Descărcarea a eșuat. Încearcă din nou."); } finally { setBusy?.(null); }
}
